<app-mat-spinner-overlay [overlay]="true" *ngIf="this.loading > 0">
</app-mat-spinner-overlay>
<div class="container-fluid PADRAO">
    <h1>Detalhe dos bloqueios</h1>
    <button type="button" mat-icon-button style="top: -10px; right: -10px; position: absolute;" matTooltip="Fechar" (click)="fechar()">
        <mat-icon aria-hidden="false" aria-label="Fechar" fontIcon="close">
        </mat-icon>
    </button>
    <div style="margin-top: 20px;">
        <ul class="breadcrumb">
            <li><strong>Onde estou:</strong></li>
            <li class="active">
                <span id="lblSubMenu"><b>{{ data.titulo }}</b></span>
            </li>
        </ul>       
        
        <div>
            <mat-form-field class="pesquisa-filtro">
                <input matInput #txtVal (keyup)="applyFilter(txtVal.value)"
                    placeholder="Digite para filtrar dados ...">
            </mat-form-field>
        </div>

        <div class="lista-container">
            <app-extended-mat-table [columns]="columns" [dataSource]="dataSource" [parent]="this"
                [validaCorLinha]="columnRowData" class="registro-operacoes"></app-extended-mat-table>
        </div>
    </div>
</div>